import React from 'react';
import { Container } from '@mui/material';
import { useIntl } from 'react-intl';
import { CATALOG_URLS } from '~/core/urls/urls';
import { NextLink } from '~/components/NextLink';
import { makeStyles } from '@mui/styles';
import { Icon } from 'components';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(4, 3),
        flex: '1 0 auto'
    },
    content: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: theme.spacing(5),

        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            textAlign: 'center'
        }
    },
    pageTitle: {
        ...theme.typography.h1,
        margin: 0
    },
    pageTextContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'center',
        textAlign: 'center',
        gap: theme.spacing(5),

        [theme.breakpoints.down('md')]: {
            alignItems: 'center'
        }
    },
    pageText: {
        ...theme.typography.subtitleLarge,
        margin: 0
    },
    warningIcon: {
        color: '#D1DBE0',
        width: 'unset',
        height: 'unset',
        maxWidth: 180,
        maxHeight: 180,
        opacity: 0.8,

        [theme.breakpoints.down('md')]: {
            width: 100,
            height: 100
        }
    },
    link: {
        color: theme.palette.secondary.main,
        '&:hover': {
            textDecoration: 'underline'
        }
    }
}));

const PageNotFoundPage = () => {
    const { formatMessage } = useIntl();
    const classes = useStyles();

    const homePageLink = (
        <NextLink href={CATALOG_URLS.base} className={classes.link}>
            {formatMessage({ id: 'media-library.header.home' })}
        </NextLink>
    );

    return (
        <Container maxWidth="lg" className={classes.container}>
            <div className={classes.content}>
                <Icon icon="warningTriangle" className={classes.warningIcon} />
                <div className={classes.pageTextContainer}>
                    <h1 className={classes.pageTitle}>
                        {formatMessage({ id: 'catalog.page-not-found.title' })}
                    </h1>
                    <p className={classes.pageText}>
                        {formatMessage(
                            { id: 'catalog.page-not-found.description' },
                            {
                                homePageLink
                            }
                        )}
                    </p>
                </div>
            </div>
        </Container>
    );
};

export default PageNotFoundPage;
